export default {
  category: 'book',
  name: 'Walden',
  author: 'Henry David Thoreau',
  date: '4/24/25',
  path: '/notes/walden',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-walden-henry-david-thoreau.jpg',
  tags: ['Biography', 'Classic'],
  time: 44,
  rating: 7.1,
  review: '',
  link: 'https://www.amazon.com/Walden-Henry-David-Thoreau/dp/1505297729',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/67d43478561807a4e142bb5a',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
